export default __webpack_public_path__ + "static/media/shuju.ea0f1698.png";